/**
 * 数智工具箱路由
 */
const routerToolbox = [
  {
    path: 'number-rotate-apply',
    name: 'NumberRotateApply',
    meta: {
      title: '数转应用',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
      // intro: '数转应用',
      // icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-13.png',
    },
    component: () => import('@/pages/module-toolbox/NumberRotateApplyHome.vue'),
  },
  {
    path: 'number-rotate-apply-detail/:id',
    name: 'NumberRotateApplyDetail',
    meta: {
      title: '工具详情',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-toolbox/NumberRotateApplyDetail.vue'),
  },
  {
    path: 'enterprise-service-match',
    name: 'EnterpriseServiceMatch',
    meta: {
      title: '企业服务',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
    },
    component: () => import('@/pages/module-toolbox/ESMHome.vue'),
  },
];

export default routerToolbox;
